import type { FaireProductEntity } from "../../entity_types/product";

export const p_u6vs98559h: FaireProductEntity = {
  token: "p_u6vs98559h",
  type: "product",
  name: "Caribbean Calcite aka Blue Aragonite Sphere Set 184g/50.2mm",
  brandToken: "b_hjv6mwysyg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ea86376cfa56387cb1076ee2f3790ac9387ba39256b998091bd9edad14718cb9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0f8f359a8a2263613e2469ac9ec1d513a74eecc7320634f15c1c0975fe02207a.jpeg",
    "https://cdn.faire.com/fastly/e6f7aeaffcb3fd3bf7315cef5700282e4111fdc41efa9196b905f2f723d76747.jpeg",
    "https://cdn.faire.com/fastly/3c2e111c760db872d821deb8b04b978a22f0f833803414ec2bc36b6e37bec920.jpeg",
    "https://cdn.faire.com/fastly/adb24de6d4cb2b51d1ce95db47cd3150188859b8932c9b4afa945f1860259b80.jpeg",
    "https://cdn.faire.com/fastly/11e721b7572fc25d9935b61daa67cd655ea12dc0c496deef577b4cfc6ec5e907.jpeg",
    "https://cdn.faire.com/fastly/120ff91332e23b342487c3bba1f184a0c38ca3af41c79a0d35cba7e708d37241.jpeg",
  ],
  priceDollars: 22.87,
  description:
    "Caribbean Calcite Crystal Sphere Gift Set with Selenite Piece for cleansing and clearing is a metaphysical healing product that combines the powerful energies of Caribbean Calcite and Selenite to promote emotional balance, stress relief, and spiritual growth. Caribbean Calcite helps us access our inner vision and connect to our higher selves, to gain a sense of purpose, a true sense of self, and begin a journey of ultimate self-discovery. It is a helpful stone during times of new beginnings and personal growth. A calming stone, Caribbean Calcite encourages us to live in the present moment. Selenite is a powerful stone that is known for its ability to cleanse and clear the mind and body of negative energy. It is also believed to promote emotional balance, stress relief, and spiritual growth. \n\nSet Includes:\nCaribbean Calcite sphere\nAcrylic Stand\nSelenite Piece\nInformational Cards\n\n***Please note that these are natural items and will have natural lines and inclusions.",
  tags: [],
  msrpDollars: 45.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:37.248Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
